import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const toastConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
}

export const ErrorMessage = (message, title) => {
  const displayMessage = title ? `${title}: ${message}` : message
  return toast.error(displayMessage, toastConfig)
}

export const InfoMessage = (message, title) => {
  const displayMessage = title ? `${title}: ${message}` : message
  return toast.info(displayMessage, toastConfig)
}

export const WarningMessage = (message, title) => {
  const displayMessage = title ? `${title}: ${message}` : message
  return toast.warning(displayMessage, toastConfig)
}

export const SuccessMessage = (message, title) => {
  const displayMessage = title ? `${title}: ${message}` : message
  return toast.success(displayMessage, toastConfig)
}
